import * as actionTypes from '../actionTypes';
import { getLoggedInUser } from "./userMe";
import { userLoginSuccess } from "./login";

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('hpa_site_info--early-bird1');
  localStorage.removeItem('hpa_site_info--early-bird2');
  localStorage.removeItem('hpa_site_info--early-bird3');
  localStorage.removeItem('hpa_site_info--early-bird4');
  localStorage.removeItem('hpa_site_info--early-bird5');
  localStorage.removeItem('hpa_site_info--early-bird6');
  localStorage.removeItem('hpa_site_info--early-bird7');
  localStorage.removeItem('hpa_site_info--early-bird8');
  localStorage.removeItem('hpa_site_info--early-bird9');
  localStorage.removeItem('hpa_site_info--early-bird10');
  localStorage.removeItem('hpa_site_info--early-bird11');
  localStorage.removeItem('hpa_site_info--early-bird12');
  localStorage.removeItem('hpa_site_info--early-bird13');
  return {
    type: actionTypes.AUTH_LOGOUT
  };
};

export const authCheckState = () => {
  return dispatch => {
    const token = localStorage.getItem('token');
    if (!token) {
      dispatch(logout());
    } else {
      dispatch(userLoginSuccess(token));
      dispatch(getLoggedInUser(token));
    }
  };
};

export const setAuthRedirectPath = (path) => {
  localStorage.setItem('redirectPath', path);
  return {
    type: actionTypes.SET_AUTH_REDIRECT_PATH,
    path: path
  }
};